import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const Footer = () => {
  const [restaurants, setRestaurants] = useState(null);
  const [links, setLinks] = useState([]);
  const { restaurant, id } = useParams();

  const formattedRestaurant = restaurant.replace(/([a-z])([A-Z])/g, "$1 $2");

  const getRestaurant = async () => {
    try {
      const response = await axios.get(
        `https://partnermeatwala.com/api/Vendor/GetVendorInfo?restname=${formattedRestaurant}&id=${id}`
      );

      const { success, vendorinfo } = response.data;

      if (success !== "1") {
        throw new Error("Failed to fetch data");
      }

      setRestaurants(vendorinfo);
    } catch (error) {
      console.error("Error fetching restaurant info:", error.message || error);
    }
  };

  const getRestaurentLink = async () => {
    try {
      const response = await axios.get(
        `https://partnermeatwala.com/api/Vendor/getsocialmedia?restid=${id}`
      );

      const { socialmedias } = response.data;

      if (!socialmedias) {
        throw new Error("No social media links found");
      }

      setLinks(socialmedias);
    } catch (error) {
      console.error("Error fetching restaurant links:", error.message || error);
    }
  };

  useEffect(() => {
    getRestaurentLink();
    getRestaurant();
  }, [getRestaurant]);

  return (
    <footer className="footer-wrapper footer-layout3">
      <div className="widget-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-3">
              <div className="widget footer-widget">
                <h3 className="widget_title text-white">Address</h3>
                <div className="th-widget-contact">
                  <div className="info-box">
                    <p className="info-box_text">{restaurants?.address}</p>
                  </div>
                  <div className="info-box">
                    <p className="info-box_text">
                      CALL:{" "}
                      <a
                        href={`tel:${restaurants?.contact}`}
                        className="info-box_link"
                      >
                        {restaurants?.contact}
                      </a>{" "}
                    </p>
                  </div>
                  <p>
                    <Link
                      to={`/${restaurant}/${id}/menu`}
                      className="th-btn style4"
                      data-ani="slideinup"
                      data-ani-delay="0.6s"
                    >
                      ORDER NOW
                      <i className="fas fa-chevrons-right ms-2"></i>
                    </Link>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="widget footer-widget text-center">
                <h3 className="widget_title text-white">Download Our App</h3>
                <a
                  href="https://apps.apple.com/us/app/meatwala/id6742139486"
                  target="_blank"
                >
                  <img
                    src="/assets/img/gplay.png"
                    alt="Download on Google Play"
                  />
                </a>
                <a
                  href="https://apps.apple.com/us/app/meatwala/id6742139486"
                  target="_blank"
                >
                  <img
                    src="/assets/img/appstore.png"
                    alt="Download on the App Store"
                  />
                </a>
                <h6 className="text-white mt-4 widget_title">
                  We Accept Credit And Debit Cards
                </h6>
                <div className="payment-img">
                  <img
                    src="/assets/paypal.png"
                    style={{ height: "40px" }}
                    alt="Accepted payment methods"
                  />
                </div>
                <div className="th-social mt-4">
                  {links?.map((link, index) => {
                    const iconClass =
                      {
                        Instagram: "fab fa-instagram",
                        Facebook: "fab fa-facebook-f",
                        TikTok: "fab fa-tiktok",
                        WhatsApp: "fab fa-whatsapp",
                      }[link.type] || "fab fa-globe";

                    return (
                      <a
                        key={index}
                        href={`https://${link.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginLeft: "10px" }}
                      >
                        <i className={iconClass}></i>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Opening Hours</h3>
                <ul className="menu listing-hour-day">
                  {restaurants?.vendorOpeningHours?.map(
                    (openingHour, index) => (
                      <li
                        key={index}
                        className="mb-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "90%",
                        }}
                      >
                        <span className="listing-hour-day">
                          {openingHour?.day}
                        </span>
                        <span className="listing-hour-time">
                          {openingHour?.opentime} - {openingHour?.closetime}
                        </span>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-2 align-items-center justify-content-center d-flex">
            <div
              className="col-md-10 text-center"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "68%",
              }}
            >
              <ul className="footerlinks">
                {[
                  { path: "terms-conditions", label: "terms & conditions" },
                  { path: "privacy-policy", label: "privacy policy" },
                  { path: "cookies", label: "cookie policy" },
                  { path: "service-disclaimer", label: "service disclaimer" },
                  { path: "contact-us", label: "contact us" },
                ].map(({ path, label }) => (
                  <li key={path}>
                    <Link to={`/${restaurant}/${id}/${path}`}>
                      {label.charAt(0).toUpperCase() +
                        label.slice(1).toLowerCase()}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-12 text-center">
              <p className="copyright-text">
                <i className="fal fa-copyright"></i> 2025 All Rights Reserved.
                Powered By{" "}
                <a href="https://meatwala.co.uk/" target="_blank">
                  Meatwala
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
